// extracted by mini-css-extract-plugin
export default {"debitAmount":"styles_debitAmount__n8Ohu","debitReference":"styles_debitReference__cQM7K"};